import getDateMonthYear from '@anm/helpers/date/getDateMonthYear';
import formatTimeWithAliases from '@anm/helpers/time/formatTimeWithAliases';

type ReportData = {
  value: number;
  label: string;
};

const getTotalPlayedTimeValue = (time: string, timeData: ReportData[]) => {
  const timeItem = timeData.find(d => d.label === time);
  const totalSeconds = timeItem?.value || 0;

  return formatTimeWithAliases(totalSeconds);
};

export const getViewsReport = (data = [] as number[]) => {
  const seconds = data.length;
  const text = 'video plays';

  const header = ['Time', 'Views'];
  const secondsArr = [2, 5];
  const percentArr = [15, 25, 50, 75, 95];

  const secondsData = data.reduce((acc, val, index) => {
    secondsArr.includes(index + 1) &&
      acc.push([`${index + 1}-second ${text}`, `${val}`]);

    return acc;
  }, [] as string[][]);

  const percentageData = data.reduce((acc, val, index) => {
    percentArr.forEach(percent => {
      ~~((seconds * percent) / 100) === index &&
        acc.push([`${percent}% ${text}`, `${val}`]);
    });

    return acc;
  }, [] as string[][]);

  return [header, ...secondsData, ...percentageData];
};

export const getPlaysReportTable = (
  playsData = [] as ReportData[],
  timeData = [] as ReportData[]
) => {
  const header = ['Date', 'Unique plays', 'Total time played'];

  const csvBodyData = playsData.map(({ value, label: timeInMs }) => {
    const [date, month, year] = getDateMonthYear(+timeInMs);
    const dateLabel = `${date}/${month}/${year}`;
    const totalPlayedTime = getTotalPlayedTimeValue(timeInMs, timeData);

    return [`${dateLabel}`, `${value}`, `${totalPlayedTime}`];
  });

  return [header, ...csvBodyData];
};
